/* eslint-disable */
import { CircularProgress, Divider, List, ListItem } from "@material-ui/core";
import React, { useEffect, useState, useMemo } from "react";
import { useLocation, withRouter } from "react-router-dom";
import { clearIntervalAsync } from "set-interval-async";
import { setIntervalAsync } from "set-interval-async/dynamic";
import { flatten } from "lodash";
import RNSmallEtaCard from "../../components/RNSmallEtaCard";
import Constants from "../../utils/constants";
import { getRouteStopEta, getRouteStopEtaByStop } from "../../utils/api";
import "./styles.scss";
import { langStringConvertor } from "../../utils/utils";

const { LANGUAGES } = Constants;
const { appTitle, routesTitle } = LANGUAGES;

const RNHome = (props) => {
  const {
    routes,
    routeIds,
    lang,
    site,
    court,
    redirect,
    displayType,
    setCurrentTitle,
    displayRouteCode,
    routeNetwork,
    showLicensePlate
  } = props;
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [etas, setEtas] = useState([]);
  const [vehicleLocations, setVehicleLocations] = useState({});

  const getEta = async () => {
    await Promise.all(
      routes.map(async (route, index) => {
        // console.log("route,route", route);
        return Promise.all(
          route.routeStops.map(async (direction, index) => {
            const tempResult = await getRouteStopEta(
              route.route_id,
              route.directions[index].route_seq
            );
            setVehicleLocations({...vehicleLocations, ...tempResult.vehicleLocation});
            // console.log("tempResult", tempResult);
            const addStopSeq = {
              ...tempResult,
              eta: tempResult.eta.map((el, ind) => {
                return { ...el, stopId: direction[ind].stop_id };
              }),
            };
            return {
              ...addStopSeq,
              routeId: route.route_id,
              routeSeq: route.directions[index].route_seq,
            };
          })
        );
      })
    ).then((result) => {
      // console.log("====result", flatten(result));
      setEtas(flatten(result));
    });
  };

  useEffect(() => {
    if (routeNetwork.length > 0) {
      // console.log("routeNetwork", routeNetwork);
    }
  }, [routeNetwork]);

  useEffect(() => {
    if (routes && routes.length > 0) {
      if (isFirstTime) {
        getEta();
        setIsFirstTime(false);
      }
      const timer = setIntervalAsync(async () => {
        await getEta();
      }, 10000);

      return () => {
        clearIntervalAsync(timer);
      };
    }
  }, [routes]);

  useEffect(() => {
    if (lang) {
      setIsLoading(false);
      setCurrentTitle(null);
    }
  }, [lang]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="progress-container"
        >
          <CircularProgress color="primary" />
        </div>
      ) : (
        <List component="nav" style={{ height: "100%", overflow: "auto" }}>
          {routeNetwork.length > 0 &&
            routeNetwork.map((route, ind) => {
              // console.log("route", route);
              // console.log("etas", etas);
              return (
                <React.Fragment key={`${route.normalRouteId}${route.routeSeq}`}>
                  <ListItem button>
                    <RNSmallEtaCard
                      origin={
                        route.normalRouteDirection[
                          `orig_${langStringConvertor(lang)}`
                        ]
                      }
                      destination={
                        route.normalRouteDirection[
                          `dest_${langStringConvertor(lang)}`
                        ]
                      }
                      stations={route.route_stops}
                      eta={etas.filter(
                        (el) =>
                          el.routeSeq === route.routeSeq &&
                          route.routeIds.includes(el.routeId)
                      )}
                      redirect={() => {
                        redirect(route.normalRouteId, route.routeSeq);
                      }}
                      language={lang}
                      displayType={displayType}
                      court={court}
                      routeCode={
                        displayRouteCode ? `${route.routeCode}: ` : null
                      }
                      showLicensePlate={showLicensePlate}
                      vehicleLocations={vehicleLocations}
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              );
            })}
        </List>
      )}
    </>
  );
};

export default withRouter(RNHome);
